import { Divider as MaterialDivider } from '@mui/material';
import React from 'react';

import type { DividerProps } from './Divider.types';
/**
 * The Divider
 *
 * @version [AIV]{version}[/AIV]
 * @author [SFP](https://gitlab.sfp.berlin/products/sparkasse.de/portals)
 * @see [https://styleguide.sparkasse.de/document/69#/ui-komponenten/divider]
 */
export const Divider: React.FC<DividerProps> = ({ variant, ...props }: DividerProps) => {
  return <MaterialDivider variant={variant} aria-hidden={variant !== 'listicle'} {...props} />;
};
